import Tooltip from "@kea-mod/common/tooltip";
import { useTranslation } from "react-i18next";

type Props = {
  activeFeedback: any;

  h: Function;
};

type ValuationOption = { id: number; name: string; labelKey: string; hintKey?: string };

// The stored value stays the level name, only the visible text is translated. A level
// carries a short explanation next to it where the name alone invites a wrong reading.
const valuationOptions: ValuationOption[] = [
  { id: 1, name: "NEGATIVE", labelKey: "valuationNegative" },
  { id: 2, name: "POSITIVE", labelKey: "valuationPositive" },
  { id: 3, name: "NEUTRAL", labelKey: "valuationNeutral", hintKey: "valuationNeutralHint" },
  { id: 4, name: "OTHER", labelKey: "valuationOther" },
];

const optionOf = (valuation: string) => valuationOptions.find((option) => option.name === valuation);

export const valuationLabel = (valuation: string, t: Function): string => {
  const option = optionOf(valuation);
  return option === undefined ? valuation : (t(option.labelKey) as string);
};

export const valuationHint = (valuation: string, t: Function): string => {
  const hintKey = optionOf(valuation)?.hintKey;
  return hintKey === undefined ? "" : (t(hintKey) as string);
};

export const ValuationField = (props: Props) => {
  const { t } = useTranslation();
  const onChange = (event: any) => {
    props.h(event);
  };

  return (
    <div className="field">
      <label className="label" htmlFor="valuation">
        {t("valuation")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-right"
          content={t("valuationTooltip")}
        ></Tooltip>
      </label>
      <div className="select">
        <select value={props.activeFeedback.valuation} onChange={onChange} id="valuation" name="valuation">
          {valuationOptions.map((option) => (
            <option key={option.id} id={option.id.toString()} value={option.name}>
              {option.hintKey === undefined
                ? t(option.labelKey)
                : t(option.labelKey) + " (" + t(option.hintKey) + ")"}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
